import { render, staticRenderFns } from "./regulation.vue?vue&type=template&id=67e51ffb&scoped=true&"
import script from "./regulation.vue?vue&type=script&lang=js&"
export * from "./regulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e51ffb",
  null
  
)

export default component.exports